/**
 * Type guard to check if a value is not `null`
 */
export const isNonNull = <T>(value: T | null): value is T => {
  return value !== null;
};
